import { FC } from 'react';

import { CarouselContainerStyled, CarouselItemStyled, CarouselStyled } from './ApplicationSlidersM.styles';

interface ApplicationSlidersMProps {
	sliders: string[];
}

export const ApplicationSlidersM: FC<ApplicationSlidersMProps> = ({ sliders }) => (
	<CarouselContainerStyled>
		<CarouselStyled autoplay>
			{sliders.map(n => (
				<CarouselItemStyled key={n}>
					<img style={{ height: `100%` }} src={n} alt='Slider item' />
				</CarouselItemStyled>
			))}
		</CarouselStyled>
	</CarouselContainerStyled>
);
